import React, { useEffect, useRef, useState } from 'react'
import { IEditableFieldProps } from './Interface'
import { useStyles } from './Styles'
import { Input } from '../input'
import { Typography } from '@material-ui/core'
import classNames from 'classnames/bind'
import { DeleteIcon } from './Styles'

const EditableField: React.FC<IEditableFieldProps> = ({
  value,
  onBlur,
  onChange,
  onRemoveValue,
  id,
  hideDeleteIcon,
  disabled
}) => {
  const container = useRef<HTMLDivElement>(null)
  const [touched, setTouched] = useState(Boolean(value))
  const [editing, setEditing] = useState(!value)
  const classes = useStyles({})

  useEffect(() => {
    const listener = (evt: any) => {
      if (disabled) return
      if (touched) {
        const e = container.current.contains(evt.target)
        setEditing(e)
      }
    }
    window.addEventListener('click', listener)
    return () => window.removeEventListener('click', listener)
  })

  const renderInput = () => {
    return Boolean(editing) && !disabled ? (
      <Input id={`${id}-label`} showLimit limit={35} initialValue={value} onBlur={onBlur} onChanged={onChange} />
    ) : (
      <Typography id={`${id}-answer`} style={{ display: 'flex', flex: 1 }}>
        <label className={classes.learning}>{value}</label>
      </Typography>
    )
  }

  const renderRemoveButton = () => {
    const hide = classNames.bind(classes)({ hide: hideDeleteIcon })
    return Boolean(editing) ? (
      <div
        className={hide}
        onClick={(evt: any) => {
          onRemoveValue(evt)
          setEditing(false)
        }}
      >
        <DeleteIcon id={`${id}-remove-button`} />
      </div>
    ) : null
  }

  return (
    <div
      className={classes.item}
      onClick={() => {
        if (!touched) {
          setTouched(true)
          setEditing(true)
        }
      }}
    >
      <div className={classes.value} ref={container}>
        {renderInput()}
      </div>
      {renderRemoveButton()}
    </div>
  )
}

export default EditableField
